export default {
    area_index: ['*', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'R', 'S', 'T', 'W', 'X', 'Y', 'Z'],
    area_code: [{
        index: '*',
        list: [
            { area: '中國香港', code: '852' },
            { area: '中國澳門', code: '853' },
            { area: '中國台灣', code: '886' },
            { area: 'Singapore', code: '65' }, // 新加坡
            { area: 'Malaysia', code: '60' }, // 马来西亚
            { area: 'Australia', code: '61' }, // 澳大利亚
            { area: 'Canada', code: '1' }, // 加拿大
            { area: 'United States', code: '1' }, // 美国
            { area: 'New Zealand', code: '64' }, // 新西兰
            { area: '日本', code: '81' }, // 日本
            { area: '대한민국', code: '82' } // 韩国
        ]
    }, {
        index: 'A',
        list: [
            { area: 'Shqipëri', code: '355' }, // 阿尔巴尼亚
            { area: 'الجزائر', code: '213' }, // 阿尔及利亚
            { area: 'افغانستان', code: '93' }, // 阿富汗
            { area: 'Argentina', code: '54' }, // 阿根廷
            { area: 'Éireann', code: '353' }, // 爱尔兰
            { area: 'مصر', code: '20' }, // 埃及
            { area: 'Eesti', code: '372' }, // 爱沙尼亚
            { area: 'Ethiopia', code: '251' }, // 埃塞俄比亚
            { area: 'الإمارات العربية المتحدة', code: '971' }, // 阿联酋
            { area: 'Aruba', code: '297' }, // 阿鲁巴
            { area: 'سلطنة عمان', code: '968' }, // 阿曼
            { area: 'Andorra', code: '376' }, // 安道尔
            { area: 'Angola', code: '244' }, // 安哥拉
            { area: 'Anguilla', code: '1264' }, // 安圭拉
            { area: 'Antigua and Barbuda', code: '1268' }, // 安提瓜和巴布达
            { area: 'Australia', code: '61' }, // 澳大利亚
            { area: 'Österreich', code: '43' }, // 奥地利
            { area: 'Azərbaycan', code: '994' } // 阿塞拜疆
        ]
    }, {
        index: 'B',
        list: [
            { area: 'Barbados', code: '1268' }, // 巴巴多斯
            { area: 'Papua New Guinea', code: '675' }, // 巴布亚新几内亚
            { area: 'Bahamas', code: '1242' }, // 巴哈马
            { area: 'Беларусі', code: '375' }, // 白俄罗斯
            { area: 'Bermuda Triangle', code: '1441' }, // 百慕大三角
            { area: 'پاکستان', code: '92' }, // 巴基斯坦
            { area: 'Paraguay', code: '595' }, // 巴拉圭
            { area: 'البحرين', code: '973' }, // 巴林
            { area: 'Panamá', code: '507' }, // 巴拿马
            { area: 'България', code: '359' }, // 保加利亚
            { area: 'Brasil', code: '55' }, // 巴西
            { area: 'Bénin', code: '229' }, // 贝宁
            { area: 'België', code: '32' }, // 比利时
            { area: 'Ísland', code: '354' }, // 冰岛
            { area: 'Botswana', code: '267' }, // 博茨瓦纳
            { area: 'Puerto Rico', code: '1787' }, // 波多黎各
            { area: 'Polska', code: '48' }, // 波兰
            { area: 'Bolivia', code: '591' }, // 玻利维亚
            { area: 'Belize', code: '501' }, // 伯利兹
            { area: 'Bosna i Hercegovina', code: '387' }, // 波斯尼亚和黑塞哥维那
            { area: 'Bhutan', code: '975' }, // 不丹
            { area: 'Burkina Faso', code: '226' }, // 布基纳法索
            { area: 'Burundi', code: '257' } // 布隆迪
        ]
    }, {
        index: 'C',
        list: [
            { area: 'Guinea Ecuatorial', code: '240' } // 赤道几内亚
        ]
    }, {
        index: 'D',
        list: [
            { area: 'Danmark', code: '45' }, // 丹麦
            { area: 'Deutschland', code: '49' }, // 德国
            { area: 'Timor Leste', code: '670' }, // 东帝汶
            { area: 'Aller', code: '228' }, // 多哥
            { area: 'República Dominicana', code: '1767' } // 多米尼加共和国
        ]
    }, {
        index: 'E',
        list: [
            { area: 'Eritrea', code: '291' }, // 厄立特里亚
            { area: 'Россия', code: '7' } // 俄罗斯
        ]
    }, {
        index: 'F',
        list: [
            { area: 'France', code: '33' }, // 法国
            { area: 'Færøerne', code: '298' }, // 法罗群岛
            { area: 'Guyane Française', code: '594' }, // 法属圭亚那
            { area: 'फिजी द्वीप समूह', code: '679' }, // 斐济群岛
            { area: 'Philippines', code: '63' }, // 菲律宾
            { area: 'Suomi', code: '358' }, // 芬兰
            { area: 'Cabo Verde', code: '238' } // 佛得角
        ]
    }, {
        index: 'G',
        list: [
            { area: 'Gambia', code: '220' }, // 冈比亚
            { area: 'Congo', code: '0242' }, // 刚果
            { area: 'Grønland', code: '299' }, // 格陵兰
            { area: 'Grenada', code: '1473' }, // 格林纳达
            { area: 'საქართველო', code: '995' }, // 格鲁吉亚
            { area: 'Colombia', code: '57' }, // 哥伦比亚
            { area: 'Costa Rica', code: '506' }, // 哥斯达黎加
            { area: 'Guadeloupe', code: '590' }, // 瓜德罗普
            { area: 'Guam', code: '1671' }, // 关岛
            { area: 'Cuba', code: '53' }, // 古巴
            { area: 'Guyana', code: '592' } // 圭亚那
        ]
    }, {
        index: 'H',
        list: [
            { area: 'Haïti', code: '509' }, // 海地
            { area: '대한민국', code: '82' }, // 韩国
            { area: 'Қазақстан', code: '07' }, // 哈萨克斯坦
            { area: 'Crna Gora', code: '382' }, // 黑山
            { area: 'Nederland', code: '31' }, // 荷兰
            { area: 'Honduras', code: '504' } // 洪都拉斯
        ]
    }, {
        index: 'J',
        list: [
            { area: 'Ghana', code: '233' }, // 加纳
            { area: 'Canada', code: '1' }, // 加拿大
            { area: 'Cambodia', code: '855' }, // 柬埔寨
            { area: 'Gabon', code: '241' }, // 加蓬
            { area: 'Djibouti', code: '253' }, // 吉布提
            { area: 'Česká republika', code: '420' }, // 捷克
            { area: '吉尔吉斯斯坦', code: '996' }, // 吉尔吉斯斯坦
            { area: 'Zimbabwe', code: '263' }, // 津巴布韦
            { area: 'Guinée', code: '224' }, // 几内亚
            { area: 'Guiné-Bissau', code: '245' } // 几内亚比绍
        ]
    }, {
        index: 'K',
        list: [
            { area: 'Cayman Islands', code: '1345' }, // 开曼群岛
            { area: 'Cameroun', code: '237' }, // 喀麦隆
            { area: 'دولة قطر', code: '974' }, // 卡塔尔
            { area: 'Hrvatska', code: '385' }, // 克罗地亚
            { area: 'Comores', code: '269' }, // 科摩罗
            { area: 'Kenya', code: '254' }, // 肯尼亚
            { area: "Côte d'Ivoire", code: '225' }, // 科特迪瓦
            { area: 'الكويت', code: '965' }, // 科威特
            { area: 'Island', code: '682' } // 库克群岛
        ]
    }, {
        index: 'L',
        list: [
            { area: 'Lesotho', code: '266' }, // 莱索托
            { area: 'ປະເທດລາວ', code: '856' }, // 老挝
            { area: 'Latvija', code: '371' }, // 拉脱维亚
            { area: 'لبنان', code: '961' }, // 黎巴嫩
            { area: 'Liberia', code: '231' }, // 利比里亚
            { area: 'ليبيا', code: '218' }, // 利比亚
            { area: 'Liechtenstein', code: '4175' }, // 列支敦士登
            { area: 'Lietuva', code: '370' }, // 立陶宛
            { area: 'România', code: '40' }, // 罗马尼亚
            { area: 'Lëtzebuerg', code: '352' }, // 卢森堡
            { area: 'Rwanda', code: '250' } // 卢旺达
        ]
    }, {
        index: 'M',
        list: [
            { area: 'Madagascar', code: '261' }, // 马达加斯加
            { area: 'Мальдивский', code: '960' }, // 马尔代夫
            { area: 'Malta', code: '356' }, // 马耳他
            { area: 'Malaysia', code: '60' }, // 马来西亚
            { area: 'Malawi', code: '265' }, // 马拉维
            { area: 'Mali', code: '223' }, // 马里
            { area: 'Mauritius', code: '230' }, // 毛里求斯
            { area: 'موريتانيا', code: '222' }, // 毛里塔尼亚
            { area: 'Македонија', code: '389' }, // 马其顿
            { area: 'Martinique', code: '596' }, // 马提尼克
            { area: 'United States', code: '1' }, // 美国
            { area: 'American Samoa', code: '684' }, // 美属萨摩亚
            { area: 'United States Virgin Islands', code: '1340' }, // 美属维尔京群岛
            { area: 'Монгол', code: '976' }, // 蒙古
            { area: 'বঙ্গ', code: '880' }, // 孟加拉
            { area: 'Montserrat', code: '1664' }, // 蒙特塞拉特
            { area: 'Micronesia', code: '691' }, // 密克罗尼西亚
            { area: 'Perú', code: '51' }, // 秘鲁
            { area: 'Moldova', code: '373' }, // 摩尔多瓦
            { area: 'المغرب', code: '212' }, // 摩洛哥
            { area: 'Monaco', code: '377' }, // 摩纳哥
            { area: 'Moçambique', code: '258' }, // 莫桑比克
            { area: 'Mexico', code: '52' } // 墨西哥
        ]
    }, {
        index: 'N',
        list: [
            { area: 'Namibia', code: '0264' }, // 纳米比亚
            { area: 'South Africa', code: '27' }, // 南非
            { area: 'Ecuador', code: '593' }, // 厄瓜多尔
            { area: 'South Sudan', code: '211' }, // 南苏丹
            { area: 'नेपाल', code: '977' }, // 尼泊尔
            { area: 'Nicaragua', code: '505' }, // 尼加拉瓜
            { area: 'Niger', code: '227' }, // 尼日尔
            { area: 'Nigeria', code: '234' }, // 尼日利亚
            { area: 'Norge', code: '47' } // 挪威
        ]
    }, {
        index: 'p',
        list: [
            { area: 'Palau', code: '680' }, // 帕劳
            { area: 'Portugal', code: '351' } // 葡萄牙
        ]
    }, {
        index: 'R',
        list: [
            { area: '日本', code: '81' }, // 日本
            { area: 'Sverige', code: '46' }, // 瑞典
            { area: 'Schweiz', code: '41' } // 瑞士
        ]
    }, {
        index: 'S',
        list: [
            { area: 'El Salvador', code: '503' }, // 萨尔瓦多
            { area: 'Србија', code: '381' }, // 塞尔维亚
            { area: 'Sierra Leone', code: '232' }, // 塞拉利昂
            { area: 'Sénégal', code: '221' }, // 塞内加尔
            { area: 'Κύπρος', code: '357' }, // 塞浦路斯
            { area: 'Seychelles', code: '248' }, // 塞舌尔
            { area: 'Samoa', code: '685' }, // 萨摩亚
            { area: 'المملكة العربية السعودية', code: '966' }, // 沙特阿拉伯
            { area: 'São Tomé e Príncipe', code: '239' }, // 圣多美和普林西比
            { area: 'Saint Kitts and Nevis', code: '1869' }, // 圣基茨和尼维斯
            { area: 'Saint Lucia', code: '1758' }, // 圣卢西亚
            { area: 'San Marino', code: '378' }, // 圣马力诺
            { area: 'Saint Vincent and the Grenadines', code: '1784' }, // 圣文森特和格林纳丁斯
            { area: 'ශ්රී ලංකාව', code: '94' }, // 斯里兰卡
            { area: 'Slovensko', code: '421' }, // 斯洛伐克
            { area: 'Slovenija', code: '386' }, // 斯洛文尼亚
            { area: 'Swaziland', code: '0268' }, // 斯威士兰
            { area: 'Sudan', code: '249' }, // 苏丹
            { area: 'Suriname', code: '597' }, // 苏里南
            { area: 'Solomon Islands', code: '677' }, // 所罗门群岛
            { area: 'Soomaaliya', code: '252' } // 索马里
        ]
    }, {
        index: 'T',
        list: [
            { area: 'ประเทศไทย', code: '66' }, // 泰国
            { area: 'Tonga', code: '676' }, // 汤加
            { area: 'Tanzania', code: '255' }, // 坦桑尼亚
            { area: 'Точикистон', code: '992' }, // 塔吉克斯坦
            { area: 'Turks and Caicos Islands', code: '1649' }, // 特克斯和凯科斯群岛
            { area: 'Trinidad and Tobago', code: '1868' }, // 特立尼达和多巴哥
            { area: 'Türkiye', code: '90' }, // 土耳其
            { area: 'تونس', code: '216' }, // 突尼斯
            { area: 'Tuvalu', code: '688' } // 图瓦卢
        ]
    }, {
        index: 'W',
        list: [
            { area: 'Vanuatu', code: '678' }, // 瓦努阿图
            { area: 'Guatemala', code: '502' }, // 危地马拉
            { area: 'Venezuela', code: '58' }, // 委内瑞拉
            { area: 'Negara Brunei', code: '673' }, // 文莱
            { area: 'Uganda', code: '256' }, // 乌干达
            { area: 'Україна', code: '380' }, // 乌克兰
            { area: 'Uruguay', code: '598' }, // 乌拉圭
            { area: "O'zbekiston", code: '998' } // 乌兹别克斯坦
        ]
    }, {
        index: 'X',
        list: [
            { area: 'España', code: '34' }, // 西班牙
            { area: 'Ελλάδα', code: '30' }, // 希腊
            { area: 'Singapore', code: '65' }, // 新加坡
            { area: 'Nouvelle Calédonie', code: '687' }, // 新喀里多尼亚
            { area: 'New Zealand', code: '64' }, // 新西兰
            { area: 'Magyarország', code: '36' }, // 匈牙利
            { area: 'سوريا', code: '963' } // 叙利亚
        ]
    }, {
        index: 'Y',
        list: [
            { area: 'Jamaica', code: '1876' }, // 牙买加
            { area: 'Հայաստան', code: '374' }, // 亚美尼亚
            { area: 'اليمن', code: '967' }, // 也门
            { area: 'Italia', code: '39' }, // 意大利
            { area: 'العراق', code: '964' }, // 伊拉克
            { area: 'ایران', code: '98' }, // 伊朗
            { area: 'भारत', code: '91' }, // 印度
            { area: 'Indonesia', code: '62' }, // 印度尼西亚
            { area: 'United Kingdom', code: '44' }, // 英国
            { area: 'The British Virgin Islands', code: '1284' }, // 英属维尔京群岛
            { area: 'ישראל', code: '972' }, // 以色列
            { area: 'الأردن', code: '962' }, // 约旦
            { area: 'Việt Nam', code: '84' } // 越南
        ]
    }, {
        index: 'Z',
        list: [
            { area: 'Zambia', code: '260' }, // 赞比亚
            { area: 'Tchad', code: '235' }, // 乍得
            { area: 'Chile', code: '56' }, // 智利
            { area: 'Afrique centrale', code: '236' }, // 中非
            { area: '中国', code: '86' },
            { area: '中國澳門', code: '853' },
            { area: '中國台灣', code: '886' },
            { area: '中國香港', code: '852' }
        ]
    }]
}


// WEBPACK FOOTER //
// ./src/util/area_code.js